import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import ActionSection from "./Sections/actions";
import BasicDetailSection from "./Sections/basicDetails";
import InformationSection from "./Sections/information";
import FieldSection from "./Sections/fields";
import CredentialSection from "./Sections/credentials";
import FeeSection from "./Sections/fees";
import LoadingSection from "./Sections/loading";
import BrokerageSection from "./Sections/brokerage";
import ProductTierSection from "./Sections/producttiers";
import SubmissionStepsSection from "./Sections/submissionSteps";
import DisclaimerSection from "./Sections/disclaimer";
import { getLender, lenderSelector } from "../../../store/slices/lenderSlice";
import PageLoader from "../../Application/PageLoader";

const Lender = React.memo(() => {
  const dispatch = useDispatch();
  const { lenderId } = useParams();
  const { lender: lenderState, requiredFieldOptions, isGettingLenderData } = useSelector(lenderSelector);

  useEffect(() => {
    if (lenderId) {
      dispatch(getLender({ lenderId }));
    }
  }, [lenderId]);

  return (
    <React.Fragment>
      {!isGettingLenderData && lenderState ? (
        <Grid container item xs={12} minWidth={"95vw"}>
          <Grid container item xs={12} padding={{ xs: 0, sm: "20px 40px 20px 40px" }}>
            <Typography
              variant="h3"
              style={{
                fontSize: "22px",
                margin: "0 0 50px",
              }}
            >
              Edit Lender Product
            </Typography>
            <BasicDetailSection lender={lenderState} />
            <ProductTierSection lender={lenderState} />
            <InformationSection lender={lenderState} />
            <ActionSection lender={lenderState} />
            <FieldSection
              lender={lenderState}
              fieldOptions={requiredFieldOptions}
            />
            {/* <CredentialSection lender={lenderState} setLender={setLender} /> */}
            <CredentialSection lenderState={lenderState} />
            <FeeSection
              lender={lenderState}
            />
            <LoadingSection lender={lenderState} />
            <BrokerageSection lender={lenderState} />
            <SubmissionStepsSection lender={lenderState} />
            <DisclaimerSection lender={lenderState} />
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          style={{
            marginTop: "64px",
            padding: "30px 0px 100px",
            height: "calc(100vh - 100px)",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "95vw",
          }}
        >
          <PageLoader text="Lender loading..." />
        </Grid>
      )}
    </React.Fragment>
  );
});

export default Lender;
